import CommonLandingContainer from '../../../../landingComponents/containers/common';
import styles from './whyLametri.module.scss';
import {
  Heading1,
  Heading2,
  Title,
  SubTitle,
  Body,
  SmallText,
  SecondaryText,
  Info,
  Button,
  Heading3,
} from '../../../../landingComponents/typography';
import InfoPanel from '../../../../landingComponents/containers/infoPanel';
import AnimatedBox from 'src/components/landingComponents/containers/animatedScroll';
import { getClassName } from 'src/Core/utility/jsx';
import { ReactComponent as CancelCircle } from 'src/assets/img/landing/redCancelCircle.svg';

const WhyLametri = () => {
  return (
    <CommonLandingContainer className={styles.container}>
      <Heading2 className={styles.header} accent>
        Почему именно Ламетри?
      </Heading2>
      <div className={styles.mainInfo}>
        <AiBlock />
        <Alternatives />
      </div>
    </CommonLandingContainer>
  );
};

export default WhyLametri;

const AiBlock = () => {
  return (
    <AnimatedBox className={getClassName([styles.aiBlock])}>
      <InfoPanel
        Header={() => (
          <Title className={styles.aiTextAccent}>
            Наша система использует комбинацию ИИ + алгоритмы
          </Title>
        )}
      >
        <div className={styles.aiTextContainer}>
          <SecondaryText className={styles.aiText}>
            Искусственный интеллект используется для подготовки данных, а
            алгоритмы для получения гарантировано однозначного решения. Никаких
            двойных трактовок!
          </SecondaryText>
          <SecondaryText className={styles.aiText}>
            Наша система не заменяет врача, она помогает быстро понять нужно ли
            и куда вам обратиться за помощью.
          </SecondaryText>
          <Body className={styles.aiTextAccent2}>
            Мы точно, быстро, однозначно и бесплатно расшифруем ваши тесты
          </Body>
        </div>
      </InfoPanel>
    </AnimatedBox>
  );
};

const Alternatives = () => {
  return (
    <div className={styles.alternatives}>
      <Title className={styles.title} accent>
        Альтернативы
      </Title>
      <div className={styles.alternativeTextBlocks}>
        <InfoBlock title="Знакомый врач">
          один человек не может знать всех заболеваний или же быть в курсе самых
          новых алгоритмов
        </InfoBlock>
        <InfoBlock title="Клиники" delay={0.2}>
          у вас может не быть времени и возможности своевременно попасть на
          приём
        </InfoBlock>
        <InfoBlock title="Поиск в интернете">
          не специалист не сможет правильно интерпретировать данные
        </InfoBlock>
        <InfoBlock title="Искусственный интеллект" delay={0.2}>
          расшифровывает анализы неточно и часто недостоверно
        </InfoBlock>
      </div>
    </div>
  );
};

const InfoBlock = ({ title, children, delay }) => {
  return (
    <AnimatedBox className={styles.alternativeInfo} delay={delay}>
      <CancelCircle className={styles.cancelCircle} />
      <InfoPanel Header={() => <Body accent>{title}</Body>}>
        <SecondaryText>{children}</SecondaryText>
      </InfoPanel>
    </AnimatedBox>
  );
};
